module.exports = __webpack_public_path__ + "SrutiChekka-8cb706b3.webp";